import type { DateTranslations } from 'utils/dates/applyDateTranslations'

export const frenchDateTranslations: DateTranslations = {
  months: {
    full: {
      January: 'janvier',
      February: 'février',
      March: 'mars',
      April: 'avril',
      May: 'mai',
      June: 'juin',
      July: 'juillet',
      August: 'août',
      September: 'septembre',
      October: 'octobre',
      November: 'novembre',
      December: 'décembre',
    },
    short: {
      Jan: 'janv.',
      Feb: 'févr.',
      Mar: 'mars',
      Apr: 'avr.',
      May: 'mai',
      Jun: 'juin',
      Jul: 'juil.',
      Aug: 'août',
      Sep: 'sept.',
      Oct: 'oct.',
      Nov: 'nov.',
      Dec: 'déc.',
    },
  },
  days: {
    full: {
      Sunday: 'dimanche',
      Monday: 'lundi',
      Tuesday: 'mardi',
      Wednesday: 'mercredi',
      Thursday: 'jeudi',
      Friday: 'vendredi',
      Saturday: 'samedi',
    },
    short: {
      Sun: 'dim.',
      Mon: 'lun.',
      Tue: 'mar.',
      Wed: 'mer.',
      Thu: 'jeu.',
      Fri: 'ven.',
      Sat: 'sam.',
    },
  },
}
